import Icon from "@repo/utils/Icon";
import UString from "@repo/utils/UString";

type PaymentMethod = {
  id: PaymentMethod.Id;
  type: PaymentMethod.Type;
  details: {
    brand: PaymentMethod.Card.Brand;
    lastFour: string;
    exp: `${string}/${string}`;
  };
};

namespace PaymentMethod {
  export type Id = `pm_${string}`;
  export const types = ["unknown", "card"] as const;
  export type Type = (typeof types)[number];

  export namespace Type {
    const iconByType = {
      card: "",
      unknown: "",
    } as const satisfies Record<Type, Icon>;
    export const icon = (type: Type | undefined) => type && iconByType[type];
  }
  export namespace Card {
    export type Brand = "visa" | "mastercard" | "amex" | "discover";
  }

  export const format = Object.assign(
    (paymentMethod: PaymentMethod | undefined) => {
      if (!paymentMethod) return "-";

      const { brand, lastFour } = paymentMethod.details;
      return `${UString.capitalize(brand)} ••••${lastFour}`;
    },
    {
      withIcon(paymentMethod: PaymentMethod) {
        if (!paymentMethod) return "-";

        // eslint-disable-next-line no-irregular-whitespace
        return `${Type.icon("card")} ${format(paymentMethod)}`;
      },
      subtitle(paymentMethod: PaymentMethod) {
        const { exp } = paymentMethod.details;
        return `Exp. ${exp}`;
      },
    },
  );
}

export default PaymentMethod;
